import { CommonIntegrationInstance } from "./mcpSlice";
import { MCPIntegrationType } from "./constants";
import Connections from "./Connections";

interface ViewConnectionsProps {
  integration: CommonIntegrationInstance & {
    techStacks?: string[];
  };
  onSelect?: (connectionId: string, integrationId: string) => void;
  selectedConnectionId?: string;
}

const ViewConnections = ({ integration, onSelect, selectedConnectionId }: ViewConnectionsProps) => {
  if (integration.type === MCPIntegrationType.EXTENSION) {
    return null;
  }

  return <Connections integration={integration} onSelect={onSelect} selectedConnectionId={selectedConnectionId} />;
};

export default ViewConnections;
